const RenderChildComponent = ({ children }) => {
  return children;
};

export default RenderChildComponent;
